/* eslint-disable multiline-ternary */
export const GLOBAL_CONFIG = {
  NEW_DESIGN: process.env.REACT_APP_NEW_DESIGN
    ? !!JSON.parse(process.env.REACT_APP_NEW_DESIGN)
    : false,
  PRODUCTION_WEBSITE: process.env.REACT_APP_WEB_PROD ?? "https://uncutgems.com",
};
export const PROD_WEBSITE_LINK = {
  HOME: GLOBAL_CONFIG.PRODUCTION_WEBSITE,
  ABOUT: `${GLOBAL_CONFIG.PRODUCTION_WEBSITE}/about`,
  PRICING: `${GLOBAL_CONFIG.PRODUCTION_WEBSITE}/pricing`,
  VIDEO_EDITING: `${GLOBAL_CONFIG.PRODUCTION_WEBSITE}/video-editing`,
  PHOTO_EDITING: `${GLOBAL_CONFIG.PRODUCTION_WEBSITE}/photo-editing`,

  // Footer Links
  VIDEO_FAQS: `${GLOBAL_CONFIG.PRODUCTION_WEBSITE}/video-editing#video-faq`,
  CARAT_CLUB_FAQS: `${GLOBAL_CONFIG.PRODUCTION_WEBSITE}/pricing#carat-club-faqs`,
  PHOTO_FAQS: `${GLOBAL_CONFIG.PRODUCTION_WEBSITE}/photo-editing#photo-faq`,

  // Socials
  INSTAGRAM: `https://www.instagram.com/uncutgems_editing/`,

  // Legal
  PRIVACY_POLICY: `${GLOBAL_CONFIG.PRODUCTION_WEBSITE}/privacy-policy`,
  TERMS_AND_CONDITIONS: `${GLOBAL_CONFIG.PRODUCTION_WEBSITE}/terms-and-condition`,

  // Credits
  SITE_CREDITS: `https://creativecabana.co/`,
};
